// Exact deadlines must include the offset printed on the ticket, avoiding
// ambiguous repeated hours during daylight-saving changes.
export default function LocateDeadlineInput({ value, onChange, disabled = false }) {
  return <details className="locate-exact-deadline">
    <summary>Exact ticket deadline (optional)</summary>
    <label>Deadline with time-zone offset
      <input aria-label="Exact ticket deadline" disabled={disabled} value={value || ""}
        placeholder="2026-10-16T17:00:00-05:00" onChange={(event) => onChange(event.target.value)} />
    </label>
    <small>An exact deadline takes priority. Leave blank to use the full “Valid through” date.</small>
  </details>;
}
